var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components-layout"},[_c('div',{staticClass:"nav-intruduce"},[_c('span',[_vm._v("总长者数 | "+_vm._s(_vm.elderNum || 0))])]),_c('div',{staticClass:"charts"},[_c('EchartsLayout',{attrs:{"option":_vm.option}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }